function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "m 7.498075,16.9961 14.6926,14.4436 c 0.66403,0.7471 1.36961,0.7471 2.11669,0 l 0.8716,-0.8716 c 0.74708,-0.6641 0.74708,-1.3697 0,-2.1167 L 12.478575,16 25.178965,3.54864 c 0.66407,-0.74708 0.66407,-1.45266 0,-2.11673 l -0.8716,-0.871599 c -0.74708,-0.747081 -1.45266,-0.747081 -2.11669,0 L 7.498075,15.0039 c -0.6641,0.6641 -0.6641,1.3281 0,1.9922 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.dd64c8482b27ee254396c30f977b2b55.svg";
export { ForwardRef as ReactComponent };